import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import Section from '../components/Section';

export default () => (
  <Section id="products">
    <h1><FormattedHTMLMessage id="pages:products:title" /></h1>
    <FormattedHTMLMessage id="pages:products:description" />
  </Section>
);



// WEBPACK FOOTER //
// ./src/sections/Products.js